import styled from "styled-components"

export const Container = styled.footer`
  width: 100%;
  height: 75px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: var(--clr-purple);
  text-align: center;
  & * {
    color: white;
    margin: 0 10px;
  }
  a {
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
      color: var(--clr-gold);
    }
  }
  @media (max-width: 992px) {
    height: 50px;
    font-size: 12px;
  }

  @media (max-width: 568px) {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    height: 100px;
  }

  & > div {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: flex;

    a {
      width: 100%;
      max-width: 25px;
      & > * {
        margin: 0 auto;
      }
    }
  }
`
